import { useMemo } from 'react';
import { formatCurrency } from '../../../../utils/formatters';
import { OrderSummary } from '../../../../types/sales.types';

export interface UseFinancialSummaryCardProps {
  orderSummary: OrderSummary;
}

export const useFinancialSummaryCard = ({ orderSummary }: UseFinancialSummaryCardProps) => {
  // Formateo de montos usando la utilidad existente
  const formattedSubtotal = useMemo(
    () => formatCurrency(orderSummary.subtotal),
    [orderSummary.subtotal],
  );

  const formattedDiscount = useMemo(
    () => formatCurrency(orderSummary.totalDiscount),
    [orderSummary.totalDiscount],
  );

  const formattedMarkup = useMemo(
    () => formatCurrency(orderSummary.totalMarkup),
    [orderSummary.totalMarkup],
  );

  const formattedTotalCharges = useMemo(
    () => formatCurrency(orderSummary.totalCharges),
    [orderSummary.totalCharges],
  );

  const formattedTotal = useMemo(
    () => formatCurrency(orderSummary.grandTotal),
    [orderSummary.grandTotal],
  );

  const formattedAmountPaid = useMemo(
    () => formatCurrency(orderSummary.amountPaid),
    [orderSummary.amountPaid],
  );

  const formattedChange = useMemo(() => formatCurrency(orderSummary.change), [orderSummary.change]);

  const formattedPendingBalance = useMemo(
    () => formatCurrency(orderSummary.pendingBalance),
    [orderSummary.pendingBalance],
  );

  // Flags condicionales para mostrar/ocultar secciones
  const hasDiscount = orderSummary.totalDiscount > 0;
  const hasMarkup = orderSummary.totalMarkup > 0;
  const hasCharges = orderSummary.totalCharges > 0;
  const hasChange = orderSummary.change > 0;
  const hasPendingBalance = orderSummary.pendingBalance > 0;

  return {
    formattedSubtotal,
    formattedDiscount,
    formattedMarkup,
    formattedTotalCharges,
    formattedTotal,
    formattedAmountPaid,
    formattedChange,
    formattedPendingBalance,
    hasDiscount,
    hasMarkup,
    hasCharges,
    hasChange,
    hasPendingBalance,
  };
};
